<template>
  <div class='EnbLink' @click="push">
    <div class="icon">
      <component tam="20px" :color="Prefes.nave.corFont" :is="data.icon"/>
    </div>
    <div :class="{ selected: data.name === FilterProdStore.categoria }" class="label">{{ data.name }}</div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { icons } from '@/components/icons'
export default {
  name: 'EnbLink',
  components: { ...icons },
  props: ['data'],
  computed: {
    ...mapGetters(['FilterProdStore', 'Prefes'])
  },
  methods: {
    ...mapActions(['changeFilterProdStore', 'GetStoreProducts', 'Loading']),
    async push () {
      this.Loading(true)
      this.$router.push(`/loja/${this.data.link}`)
      this.changeFilterProdStore({ categoria: this.data.link })
        .then(() => {
          this.GetStoreProducts({ params: { last: [], limit: 8, categoria: this.data.link }, init: true })
            .then(() => this.Loading(false))
        })
    }
  }
}
</script>

<style scoped>
.EnbLink {
  height: 100%;
  width: 150px;
  display: flex;
  align-items: center;
  padding-left: 2%;
  padding-right: 2%;
  font-size: 18px;
  margin-top: 1%;
}

.icon {
  padding-right: 5%;
}

.label {
  cursor: pointer;
}

.selected {
  color: orange
}

img {
  width: 20px;
  height: 20px;
  cursor: pointer;
}
</style>
